var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRideStartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_703_23707)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_703_23707)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 4,
    width: 28,
    height: 28,
    rx: 14,
    transform: "rotate(90 34 4)",
    fill: "#148E20",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 3,
    width: 30,
    height: 30,
    rx: 15,
    transform: "rotate(90 35 3)",
    stroke: "white",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1405 26.2502L21.1405 26.2501L21.1302 26.25C20.9733 26.2489 20.821 26.1973 20.6957 26.103C20.5704 26.0087 20.4787 25.8766 20.4342 25.7261L20.4342 25.7261L20.4326 25.7209L18.592 19.7396L18.5141 19.4867L18.2612 19.4088L12.2799 17.5682L12.2799 17.5682L12.2749 17.5667C12.1244 17.5221 11.9923 17.4304 11.8979 17.305C11.8039 17.1801 11.7524 17.0283 11.7508 16.872V16.8508H11.7508L11.7508 16.8461C11.7494 16.6922 11.7964 16.5418 11.8854 16.4163C11.9743 16.2907 12.1005 16.1963 12.2461 16.1466L12.2461 16.1467L12.2582 16.1422L25.9807 11.0545L26.0027 11.047C26.1354 11.0013 26.2783 10.9937 26.4151 11.0252C26.5519 11.0567 26.6771 11.126 26.7765 11.2251C26.8759 11.3243 26.9455 11.4493 26.9773 11.586C27.0091 11.7228 27.0019 11.8657 26.9566 11.9985L26.9564 11.9985L26.9525 12.011L26.9525 12.011L21.8586 25.7425L21.8584 25.7424L21.8543 25.7547C21.8037 25.9026 21.7072 26.0305 21.5787 26.1196C21.4503 26.2088 21.2968 26.2545 21.1405 26.2502Z",
    fill: "#F9FBFF",
    stroke: "#F9FBFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_703_23707",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.14902 0 0 0 0 0.882353 0 0 0 0 0.819608 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_703_23707"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_703_23707",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_703_23707",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0790972 0 0 0 0 0.558333 0 0 0 0 0.127021 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_703_23707"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_703_23707",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRideStartIcon);
export default __webpack_public_path__ + "static/media/RideStartIcon.98ecb778bd1e711274b4294619a3dff9.svg";
export { ForwardRef as ReactComponent };